var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"apple-store",attrs:{"href":_vm.link,"target":"_blank","rel":"noopener"},on:{"click":function($event){return _vm.$emit('open-store', 'iOS')}}},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":"Download on the App Store","width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }